import { PeriodizationType, PeriodizationWorkoutInstanceExercisesType } from '../types/periodizations.type';
import { HTTPServices } from './base.service';

export class PeriodizationsServices extends HTTPServices {
    private static BASE_ROUTE = 'periodizations/';

    static getAll() {
        return PeriodizationsServices.get<PeriodizationType[]>(PeriodizationsServices.BASE_ROUTE);
    }

    static add(data: PeriodizationType) {
        return PeriodizationsServices.post<PeriodizationType>(PeriodizationsServices.BASE_ROUTE, data, 'raw');
    }

    static update(id: string, data: PeriodizationType) {
        return PeriodizationsServices.put<PeriodizationType>(PeriodizationsServices.BASE_ROUTE + id, data, 'raw');
    }

    static getById(id: number) {
        return PeriodizationsServices.get<PeriodizationType>(PeriodizationsServices.BASE_ROUTE + id);
    }

    static deleteById(id: number) {
        return PeriodizationsServices.delete<PeriodizationType[]>(PeriodizationsServices.BASE_ROUTE + id);
    }

    static getWorkoutExercises(periodization_instance_id: number) {
        return PeriodizationsServices.get<PeriodizationWorkoutInstanceExercisesType[]>(PeriodizationsServices.BASE_ROUTE + `workout/exercises?instance_id=${periodization_instance_id}`);
    }

    static updateWorkoutExercise(data: {
        instance_id: number;
        station_number: number;
        exercise_id: number;
    }) {
        return this.put<PeriodizationWorkoutInstanceExercisesType[]>(this.BASE_ROUTE + `workout/exercise`, data, 'raw');
    }
}
